import React from "react";
import { Router, Route, IndexRoute } from "react-router";
import ReactPixel from "react-facebook-pixel";

import App from "./components/app";

import Introduction from "./views/introduction";

import Agency from "./views/products/agency";
import Artist from "./views/products/artist";

// import Collaboration from "./views/features/collaboration";

import Pricing from "./views/pricing";

import Influencers from "./views/cases/influencers";
// import Speakers from "./views/cases/speakers";

import Trial from "./views/trial";
import SignUp from "./views/sign-up";
import SignUpAgency from "./views/sign-up-agency";

import Roster from "./views/roster";

import RequestCall from "./views/request-call";

import Contact from "./views/contact";
import Privacy from "./views/privacy";

const fireTracking = () => {
  window.gtag("config", "UA-54302551-2", {
    page_location: window.location.pathname,
  });
  window.scrollTo(0, 0);

  ReactPixel.pageView();
};

const Routes = (props) => (
  <Router onUpdate={fireTracking} {...props}>
    <Route path="/" component={App}>
      <IndexRoute component={Introduction} />

      <Route path="/products/agency" component={Agency} />
      <Route path="/products/artist" component={Artist} />

      {/* <Route path="/features/collaboration" component={Collaboration} /> */}

      <Route path="/pricing" component={Pricing} />

      <Route path="/cases/influencers" component={Influencers} />

      <Route path="/trial" component={Trial} />
      <Route path="/sign-up" component={SignUp} />
      <Route path="/sign-up/agency" component={SignUpAgency} />

      <Route path="/roster" component={Roster} />

      <Route path="/request-call" component={RequestCall} />

      <Route path="/contact" component={Contact} />
      <Route path="/privacy" component={Privacy} />
    </Route>
  </Router>
);

export default Routes;



// WEBPACK FOOTER //
// src/routes.js